export const fetchBooleanQuizzes = async () => {
  try {
    const response = await fetch(
      "https://zg3olhj6ke.execute-api.us-east-1.amazonaws.com/quiz/boolean",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    const quizzes = data.quizzes || [];

    const normalized = quizzes.slice(0, 10).map((q) => ({
      headline: q.headline,
      correct_answer: q.correctAnswer,        // ✅ 重点：对齐你原本组件逻辑
      feedback: q.feedback,
      tip: q.tip,
      summary: q.summary,
      image_url: q.imageUrl,
      ...q, // 其余字段保留
    }));

    return normalized;
  } catch (error) {
    console.error("Error fetching boolean quizzes:", error);
    return [];
  }
};